
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface PatientinstructionParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface  PatientinstructionMst {
    id?: number;
    notes: string;    
    visitId:any;
    regId: string;
    instructionId: any; 
    tenantId: any;
    branchId: any;
    
    //LOG
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    parameters?: PatientinstructionParameter[];
    links?: any;
    performingDoctor?:string;
    performingNurse?:string;
}


export abstract class PatientinstructionData { 

    abstract list(url: string): Observable<PatientinstructionMst[]>;
    abstract create(url: string, data: PatientinstructionMst): Observable<any>;
    abstract update(url: string, data: PatientinstructionMst): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}

